import Paper from "@mui/material/Paper";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import AddIcon from "@mui/icons-material/Add";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Typography from "@mui/material/Typography";
import React from "react";
import { useRef } from "react";
import Stack from "@mui/material/Stack";
import Snackbar from "@mui/material/Snackbar";
import DeleteIcon from "@mui/icons-material/Delete";
import Alert from "@mui/material/Alert";
import Autocomplete from "@mui/material/Autocomplete";

function FreeList({ single, plural, list, min, max, warrant, options, otherList }) {
  const currentAKA = useRef();

  const removeAKA = (aka) => () => {
   

    list((prevAkas) => prevAkas.filter((c) => c !== aka));
  };

  const [open, setOpen] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState("");

  const addAKA = () => {
    let curName = currentAKA.current.value;

    if (curName === null || curName === undefined) {
      return;
    }
    if (curName.trim().length < min) {
      setErrorMessage(`${single} must be at least ${min} characters`);
      setOpen(true);

      return;
    }
    if (curName.trim().length > max) {
      setErrorMessage(`${single} cannot be longer than ${max} characters`);
      setOpen(true);

      return;
    }

    if (warrant.includes(curName)) {
      setErrorMessage(`Your ${single} Is already in the warrant`);
      setOpen(true);

      return;
    }

    if (otherList.includes(curName)) {
      setErrorMessage(`Your ${single} is already in the list`);
      setOpen(true);

      return;
    }
    list((prevAkas) => [...prevAkas, curName]);
    currentAKA.current.value = ""; // Clear the input field
    // handleClose();
  };

  const handleClose = (event, reason) => {
    setOpen(false);
  };
  return (
    <Paper elevation={1} sx={{ width: "100%" }}>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert severity="error" sx={{ width: "100%" }}>
          {errorMessage}
        </Alert>
      </Snackbar>
      <Typography variant="body1" sx={{ p: 2 }}>
        {plural} ({otherList.length})
      </Typography>
      <Stack
        spacing={2}
        sx={{ p: 2 }}
        justifyContent="center"
        alignItems="flex-start"
      >
        <List
          disablePadding
          sx={{ width: "100%", p: 0 }}
          subheader={
            (single !== "SMT" && single !== "CMC") ? (
              <TextField
                label={single}
                size="small"
                sx={{ width: "100%", marginBottom: 2 }}
                inputRef={currentAKA}
                slotProps={{
                  input: {
                    endAdornment: (
                      <InputAdornment>
                        <IconButton edge="end" onClick={addAKA}>
                          <AddIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                  },
                }}
              ></TextField>
            ) : (
              <Autocomplete
                disablePortal
                options={options}
                autoHighlight
                autoSelect
                autoComplete
                multiple={true}
                renderValue={() => null}
                size="small"
                sx={{ width: "100%", marginBottom: 2 }}
                renderInput={(params) => (
                  <TextField {...params} label={single} />
                )}
                value={otherList}
                onChange={(event, newValue) => {
                  if (newValue.length > otherList.length) {
                    currentAKA.current = {
                      value: newValue[newValue.length - 1],
                    };
                    addAKA();
                  }
                }}
              />
            )
          }
        >
          {otherList.map((aka) => (
            <ListItem
              disableGutters
              key={aka}
              sx={{ paddingLeft: 1 }}
              secondaryAction={
                <IconButton
                  edge="end"
                  aria-label="delete"
                  sx={{ padding: 2 }}
                  onClick={removeAKA(aka)}
                >
                  <DeleteIcon color="error" />
                </IconButton>
              }
            >
              {aka}
            </ListItem>
          ))}
        </List>
      </Stack>
    </Paper>
  );
}

export default FreeList;
